module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_WPN PFCs FREE LEATHER_deskstop.63a6e8bf.jpg";